// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"836f0670","488":"79c0fd3f","977":"14a8bf51"}[chunkId] + ".chunk.js";
};